import React from 'react';
import GroupIcon from '@mui/icons-material/Group';
import eventFormatter from '#component/device/event-formatter';
import PreloaderComponent from '#component/preloader';
import { EmptyLogs } from '#component/user/log/empty-log';
import EventDescription from '#component/user/log/event-description';
import LogCard from '#component/general/log-card';
import { LoadingList } from './styles';

/**
 * Renders cards with log info.
 * @returns {React.FC}
 */

const MobileView = props => {
  const { account, loading, error, logs } = props;

  if (!logs.length && loading) {
    return <PreloaderComponent />;
  }

  if (error) {
    return <EmptyLogs />;
  }

  return (
    <LoadingList loading={loading}>
      {logs.length > 0 ? (
        logs.map((log, i) => (
          <LogCard
            key={i}
            log={log}
            account={account}
            icon={<GroupIcon />}
            EventDescriptionComponent={EventDescription}
            eventFormatter={eventFormatter}
          />
        ))
      ) : (
        <EmptyLogs />
      )}
    </LoadingList>
  );
};

export default MobileView;
